import React, { useContext } from 'react'

import { forgotPasswordFormControl } from '../../../config'
import { AuthContext } from '../../../contexts/auth-context'
import CommonForm from '../../common-form'

function ForgotPassword() {
  const { handleForgotPasswordButtonClick, forgotPasswordFormdata, setForgotPasswordFormdata } =
    useContext(AuthContext)

  return (
    <>
      <CommonForm
        formControls={forgotPasswordFormControl}
        formData={forgotPasswordFormdata}
        setFormData={setForgotPasswordFormdata}
        handleSubmit={handleForgotPasswordButtonClick}
        buttonText="Forgot Password"
        isButtonDisabled={false}
        buttonClass="bg-heading-primary rounded-sm text-base px-3 py-3 sm:py-6 w-full cursor-pointer hover:bg-heading-primary-400"
      />
    </>
  )
}

export default ForgotPassword
